import { LauncherMessages, TranslationLauncherMessages } from "../interfaces";

export const messages: TranslationLauncherMessages = {
  [LauncherMessages.launcherSelectModule]: "Selecione o módulo para continuar",
  [LauncherMessages.launcherGreeting]: "Olá, {{name}}",
  [LauncherMessages.launcherActiveCount]: "{{count}} módulos ativos",
  [LauncherMessages.launcherContactUs]: "Fale conosco para desbloquear",
  [LauncherMessages.launcherNoAccessTooltip]: "Solicite acesso ao admin desta empresa",
  [LauncherMessages.launcherModuleDescTech]: "Controle e gestão do concreto pelo domínio da tecnologia",
  [LauncherMessages.launcherModuleDescFleet]: "Aumente a produtividade com rastreador para sua concreteira",
  [LauncherMessages.launcherModuleDescDispatch]: "Simplificando por completo o processo logístico do concreto",
  [LauncherMessages.launcherModuleDescCustomer]: "Aplicativo do cliente com visualização macro da obra",
  [LauncherMessages.launcherModuleDescBi]: "Business intelligence alinhado à gestão do concreto",
  [LauncherMessages.launcherModuleDescCrm]: "Gerenciamento total de contratos de forma simples e transparente",
  [LauncherMessages.launcherModuleDescBilling]: "Faturamento com apenas alguns cliques",
  [LauncherMessages.launcherModuleDescFinances]: "Controle e gestão financeira do concreto",
  [LauncherMessages.launcherModuleDescPurchase]: "Entrada de notas, combustível e estoque de matéria-prima",
  [LauncherMessages.launcherModuleDescBatch]: "Automação do processo de pesagem",
  [LauncherMessages.launcherModuleDescReports]: "Relatórios e indicadores da operação do concreto",
  [LauncherMessages.launcherModuleDescBackoffice]: "Retaguarda: compras, financeiro e faturamento",
  [LauncherMessages.launcherModuleDescFmx]: "Gestão da frota e operação de concreto",
  [LauncherMessages.launcherModuleDescDriver]: "App do motorista/bombista",
  [LauncherMessages.launcherModuleDescFmxSuite]: "Gestão (FMX) e app do motorista (DRIVER)",
  [LauncherMessages.launcherModuleDescIdentity]: "Gestão de identidade, acessos e permissões da suíte Topcon",
  [LauncherMessages.launcherModuleTaglineCrm]: "Contratos sob controle, do orçamento à assinatura.",
  [LauncherMessages.launcherModuleTaglineBilling]: "Fature mais rápido com zero burocracia.",
  [LauncherMessages.launcherModuleTaglineFinances]: "Sua saúde financeira sob controle total.",
  [LauncherMessages.launcherModuleTaglinePurchase]: "Reduza custos com compras inteligentes.",
  [LauncherMessages.launcherModuleTaglineBatch]: "Pesagem automática, traço sob controle.",
  [LauncherMessages.launcherUpsellNote]:
    "Este módulo não está contratado. Entre em contato com seu consultor Topcon.",
  [LauncherMessages.launcherLicenseWarning]:
    "Sua licença vence em {{count}} dias. Contate o setor financeiro para renovar.",
  [LauncherMessages.launcherLicenseExpiredTitle]: "Licença vencida",
  [LauncherMessages.launcherLicenseExpiredText]:
    "A licença da sua empresa expirou. Contate o setor financeiro para renovar o acesso.",
  [LauncherMessages.launcherLoading]: "Carregando seus módulos...",
  [LauncherMessages.launcherLoadError]: "Não foi possível carregar seus módulos. Tente novamente."
};
